import React, { useState } from 'react';
import './ChangeCategoryModal.css';

function ChangeCategoryModal({ isOpen, onClose, onSave, currentCategory, imageName }) {
  const [category, setCategory] = useState(currentCategory || 'متنوعة');
  const [isSaving, setIsSaving] = useState(false);

  const categories = [
    'الفقه',
    'العقيدة',
    'الحديث',
    'التفسير وعلوم القرآن',
    'السيرة النبوية',
    'السير والتراجم',
    'الرقائق',
    'الآداب والأخلاق',
    'الوسواس القهري',
    'وصايا علمية',
    'متفرقات'
  ];

  if (!isOpen) return null;

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onSave(category);
      onClose();
    } catch (error) {
      console.error('Error saving category:', error);
      alert('❌ حدث خطأ أثناء حفظ التصنيف');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="change-category-modal-overlay" onClick={onClose}>
      <div className="change-category-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="change-category-modal-header">
          <h2 className="change-category-modal-title">
            🏷️ تغيير التصنيف
          </h2>
          <button className="close-modal-btn" onClick={onClose}>
            ✖️
          </button>
        </div>
        
        <div className="change-category-modal-body">
          <div className="image-name-display">
            <span className="label">التصميم:</span>
            <span className="value">{imageName}</span>
          </div>
          
          <div className="category-selector-main">
            <label htmlFor="category-select-main">اختر التصنيف:</label>
            <select
              id="category-select-main"
              className="category-select-main"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              disabled={isSaving}
            >
              {categories.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="change-category-modal-footer">
          <button 
            className="btn-cancel-category" 
            onClick={onClose}
            disabled={isSaving}
          >
            إلغاء
          </button>
          <button 
            className="btn-save-category" 
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? '⏳ جاري الحفظ...' : '💾 حفظ التصنيف'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChangeCategoryModal;
